import { NetworkErrorModal } from './components/modals/NetworkErrorModal';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@material-tailwind/react';
import { browserRouter } from '@src/routes.tsx';
import { defaultTheme } from './themes/default';
import { ToastProvider } from './contexts/ToastProvider';
import { UpdateChecker } from './hooks/UpdateChecker';

const App = () => {
  return (
    <ThemeProvider value={defaultTheme}>
      <NetworkErrorModal />
      <ToastProvider>
        <UpdateChecker />
        <RouterProvider router={browserRouter} />
      </ToastProvider>
    </ThemeProvider>
  );
};

export default App;
